<script>
import CategoryFacet from '../lib/category-facet.vue'
import ForMeTool from '../lib/for-me-tool.vue'
import CollapsibleSearch from '../lib/collapsible-search.vue'

export default {
    components: {CategoryFacet, ForMeTool, CollapsibleSearch},
    props: {
        search: {type: String, default: ''},
        categories: {type: Array, default: () => []},
        forMeActive: {type: Boolean, default: false},
    },

    computed: {
        searchActive() {
            return this.searchInput != ''
        }
    },

    data() {
        return {
            searchInput: this.search,
        }
    },

    methods: {
        onSearchInput() {
            if (this.searchInput === '') this.$emit('delete-search')
        }
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg navbar-light bg-light px-2">
  <div class="d-flex align-items-center flex-wrap gap-1">
    <for-me-tool :active="forMeActive" @click="$emit('toggle-for-me')" />
    <ul class="navbar-nav">
      <category-facet :value="categories" @change="$emit('categories', $event)" />
    </ul>
  </div>

  <collapsible-search class="ms-auto" :value="search"
    @search="$emit('search', $event)" @delete-search="$emit('delete-search')" />
</nav>
</template>